import { ChannelType, QueueMediaType } from '@dxp/core/types';

export const channelTypeToQueueMediaType = (
    channelType: ChannelType,
): QueueMediaType => {
    switch (channelType) {
        case 'voice':
            return 'Voice';
        case 'email':
            return 'Email';
        case 'webchat':
            return 'Webchat';
        default:
            return 'Socials';
    }
};
